import React, { Component } from 'react';
import loadSchedule         from '../LoadEventSchedule';
import Loader               from 'react-loader-spinner';
import Slider               from '../components/Slider/Slider';

class MkCases2021 extends Component {
    state = {
        event: [],
        error: null,
        isLoaded: false,
        slides: [
            {
                path: './img/MK-CASES-2021/a2a.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/calendar.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/events.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/fb.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/hr.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/mentor.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/rider.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/schedule.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/strateg.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/ta.png',
                background: '',
                type: 'image'
            },
            {
                path: './img/MK-CASES-2021/youtube.png',
                background: '',
                type: 'image'
            },
        ]
    };


    render() {
        // Лоадер для данных
        // if (!this.state.isLoaded) {
        //     return (
        //         <div className="b-loader">
        //             <Loader type="Watch" color="#bbb" height="100" width="100"/>
        //         </div>
        //     );
        // }

        return (
            <Slider slides={ this.state.slides }/>
        );
    }

}

export default MkCases2021;
